import { SaleConstant } from '../constants';
import { RequestAction } from '.';

export const createSale = data =>
  RequestAction.request(SaleConstant.CREATE_SALE, {
    data,
    method: 'post',
    url: `/api/sale`,
  });

export const deleteSale = id =>
  RequestAction.request(SaleConstant.DELETE_SALE, {
    method: 'delete',
    url: `/api/sale/${id}`,
  });

export const deleteTransactionSale = (saleId, transactionId) =>
  RequestAction.request(SaleConstant.DELETE_TRANSACTION_SALE, {
    method: 'delete',
    url: `/api/sale/${saleId}/transaction/${transactionId}`,
  });

export const editCustomSale = (id, data) =>
  RequestAction.request(SaleConstant.EDIT_CUSTOM_SALE, {
    data,
    method: 'put',
    url: `/api/sale/${id}/custom`,
  });

export const editSale = (id, data) =>
  RequestAction.request(SaleConstant.EDIT_SALE, {
    data,
    method: 'put',
    url: `/api/sale/${id}`,
  });

export const getSale = id =>
  RequestAction.request(SaleConstant.GET_SALE, { url: `/api/sale/${id}` });

export const getSales = params =>
  RequestAction.request(SaleConstant.GET_SALES, { params, url: '/api/sale' }, false);

export const markPaidSale = id =>
  RequestAction.request(SaleConstant.MARK_PAID_SALE, {
    method: 'put',
    url: `/api/sale/${id}/mark-paid`,
  });

export const receiveSale = (id, data) =>
  RequestAction.request(SaleConstant.RECEIVE_SALE, {
    data,
    method: 'put',
    url: `/api/sale/${id}/receive`,
  });

export const setSale = payload => ({
  payload,
  type: SaleConstant.SET_SALE,
});

export const setSales = payload => ({
  payload,
  type: SaleConstant.SET_SALES,
});
